// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__4a0ux","buttons":"PendingPaymentAlert_buttons__8FuDd"};